import React from 'react';
import { styled } from "../stitches.config"
import { h2, bodyLarge } from "./commonStyles/Fonts";
import Media from '../components/common/Media';

import YouTube from "./assets/icons/medialinks/youtube.svg"
import Apple from "./assets/icons/medialinks/apple.svg"
import Spotify from "./assets/icons/medialinks/spotify.svg"
import PodcastPosterPlaceholder from './components/PodcastPlayer/PodcastPosterPlaceholder';

type ExtendedProps = {
    date?: string;
    length?: string;
    series?: string;
    spotify?: string;
    youtube?: string;
    apple?: string;
    title: string;
    poster?: any;
};

type HeaderPodcastProps = {
    element: ExtendedProps
}

const HeaderPodcast: React.FC<HeaderPodcastProps> = ({
    element
}) => {
    const isDesktop = window.innerWidth > 996;
    const {
        date,
        length,
        series,
        spotify,
        youtube,
        apple,
        title,
        poster
    } = element;

    return (
        <StyledHeaderPodcast>
            <Poster>
                {poster && <Media
                    media={poster.media}
                    src={poster.img}
                    alt={title}
                    height={300}
                    width={300}
                    aspectRatio={1}
                    preserveRatio={false}
                />}
                {!poster && <PodcastPosterPlaceholder />}
            </Poster>
            <HeaderPodcastContent>
                {isDesktop && <div className={bodyLarge()}>{date}<span></span>{length}</div>}
                <h2 className={h2()}>{title}</h2>
                <p className={bodyLarge()}>{series ? series : ''}</p>
                <MediaLinks>
                    {spotify && <a className="spotify" href={spotify} target="_blank"></a>}
                    {apple && <a className="apple" href={apple} target="_blank"></a>}
                    {youtube && <a className="yt" href={youtube} target="_blank"></a>}
                </MediaLinks>
            </HeaderPodcastContent>
        </StyledHeaderPodcast>
    );
};

const StyledHeaderPodcast = styled('div', {
    display: "flex",
    flexDirection: "column",
    paddingTop: '24px',
    "@bp4": {
        flexDirection: "row",
        alignItems: "center",
        // póki są breadcrumbs
        marginTop: "16px",
    }
});

const Poster = styled('div', {
    width: "100%",
    "@bp4": {
        maxWidth: "300px",
        height: "300px",
        marginRight: "24px",
    }
});

const HeaderPodcastContent = styled('div', {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    "& h2": {
        margin: "24px 0 4px 0",
        "@bp4": {
            margin: "8px 0",
        }
    },
    "& p": {
        margin: 0,
        color: '$primary',
    },
    "& span": {
        margin: "0 8px",
        width: "1px",
        height: "12px",
        backgroundColor: "$grayscale25",
    },
    "& div": {
        display: "flex",
        alignItems: "center",
    }
});

const MediaLinks = styled('div', {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    margin: "16px 0 0 0",
    "@bp4": {
        margin: "24px 0 0 0",
        justifyContent: "flex-start",
        width: "auto",
    },
    "& a": {
        width: "100px",
        height: "40px",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "@bp4": {
            marginRight: "16px",
        }
    },
    "& .yt": {
        backgroundImage: `url("${YouTube}")`,
    },
    "& .spotify": {
        width: "106px",
        backgroundImage: `url("${Spotify}")`,
    },
    "& .apple": {
        backgroundImage: `url("${Apple}")`,
    },
});

export default HeaderPodcast;